import {
    Component,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    ViewChild,
} from '@angular/core';
import { NgbTabset } from '@cmps/ng-bootstrap';
import { of, Subscription } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';

import { CMPS_WIDGET_OPTIONS } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import {
    TdbfgCompliancePopup,
    TdbfgCompliancePopupUser,
} from './tdbfg-compliance.widget.model';

@Component({
    selector: 'cmps-widget-tdbfg-compliance',
    templateUrl: './tdbfg-compliance.widget.component.html',
})
export class TdbfgComplianceWidgetComponent implements OnInit, OnDestroy {
    @ViewChild('popupEl') private readonly _popupEl: ElementRef;
    @ViewChild('tabSet') private readonly _tabSet: NgbTabset;

    @Input() options: any;

    i18n = TranslationKeyMap;
    private _sub: Subscription;
    hasPendingData: boolean;
    data: TdbfgCompliancePopup;
    currentDetail: TdbfgCompliancePopupUser;
    activeTabId: string;

    constructor(
        @Optional() @Inject(CMPS_WIDGET_OPTIONS) private readonly _options: any,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
    ) {
        this.options = _options || this.options;
    }

    ngOnInit(): void {
        this._sub = this._widgetService.dateRange
            .pipe(
                tap(() => {
                    this.data = null;
                    this.currentDetail = null;
                    this.hasPendingData = true;
                }),
                switchMap(() =>
                    this._service
                        .tdbfgCompliancePopup(this.options.definitionId)
                        .pipe(
                            catchError(() => of(null)),
                            tap((data) => {
                                this.data = data;
                                this.hasPendingData = false;
                            }),
                        ),
                ),
                // eslint-disable-next-line no-return-assign
                finalize(() => (this.hasPendingData = false)),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }

    showDetails(item: TdbfgCompliancePopupUser): void {
        this.currentDetail = item;
        this.activeTabId = this._tabSet.activeId;
        // eslint-disable-next-line no-return-assign, @typescript-eslint/restrict-plus-operands
        setTimeout(
            () =>
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                (document.querySelector('ngb-modal-window').scrollTop +=
                    this._popupEl.nativeElement.getBoundingClientRect().top),
        );
    }
}
